"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _includes = _interopRequireDefault(require("lodash/fp/includes"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["size", "type", "children", "className"];
var BasicAlertButton = function BasicAlertButton(_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    type = _ref.type,
    children = _ref.children,
    className = _ref.className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var ignoreTypeParam = (0, _includes["default"])(type)(['primary', 'secondary']);
  var classToApply = (0, _classnames["default"])({
    'alert-btn-primary': type === 'primary',
    'alert-btn-secondary': type === 'secondary'
  }, className);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    ref: ref,
    size: size,
    className: classToApply,
    type: ignoreTypeParam ? undefined : type
  }, rest), children);
};
var AlertButton = /*#__PURE__*/_react["default"].forwardRef(BasicAlertButton);
var _default = exports["default"] = AlertButton;